import { Injectable, Inject } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { IPanelService, PANEL_SERVICE } from '../services/IPanel.service';
import * as PanelActions from './panel.actions';

@Injectable()
export class PanelEffects {
  loadPanel$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PanelActions.PanelActionTypes.loadPanelBegin),
      switchMap(() =>
        this.service.getPanelData().pipe(
          map((panel) =>
            PanelActions.loadPanelSuccessAction({ payload: panel })
          ),
          catchError((error) => {
            console.error('Could not load main panel', error);
            return of(PanelActions.loadPanelFailAction({ errors: error }));
          })
        )
      )
    )
  );

  loadPanelAnalytics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PanelActions.getAnalyticsBeginAction),
      switchMap((action) =>
        this.service.getPanelAnalytics(action.filter).pipe(
          map((panel) =>
            PanelActions.getAnalyticsSuccessAction({ payload: panel })
          ),
          catchError((error) => {
            console.error('Could not load main panel', error);
            return of(PanelActions.getAnalyticsFailAction({ errors: error }));
          })
        )
      )
    )
  );

  getEcwidStadistics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PanelActions.getEcwidDataStatusBeginAction),
      switchMap((action) =>
        this.service.getEcwidStadistics().pipe(
          map((data) =>
            PanelActions.getEcwidDataStatusSuccessAction({ data })
          ),
          catchError((error) => {
            console.error('Could not load ecwid data', error);
            return of(PanelActions.getEcwidDataStatusFailAction({ errors: error }));
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    @Inject(PANEL_SERVICE) private service: IPanelService
  ) {}
}
